import { createContext, useContext, useEffect } from 'react';
import { useProducts } from '../hooks/useProducts';
import { warmStoreBackend } from '../services/api';

const ProductsContext = createContext(null);

/** Products refresh every 20s + on tab focus; backend warmed on first load. */
export const ProductsProvider = ({ children }) => {
  const value = useProducts(20_000);

  useEffect(() => {
    warmStoreBackend();
  }, []);

  return <ProductsContext.Provider value={value}>{children}</ProductsContext.Provider>;
};

export const useProductsContext = () => {
  const ctx = useContext(ProductsContext);
  if (!ctx) throw new Error('useProductsContext must be used within ProductsProvider');
  return ctx;
};
